import React from 'react';
import { Box, Heading, Input, Text } from '@chakra-ui/react';

export const ROLE_TITLE_MAX_LENGTH = 100;

// The person's role title: plain text in view mode, a single-line input (no formatting
// toolbar) in edit mode.
const RoleTitleSection = ({ isEditing, value, displayValue, onChange }) => (
  <Box bg="white" boxShadow="md" borderRadius="md" p={6} mb={6}>
    <Heading as="h2" size="md" mb={2}>
      Role Title
    </Heading>
    {isEditing ? (
      <Input
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        maxLength={ROLE_TITLE_MAX_LENGTH}
        placeholder="e.g. Senior Backend Engineer"
        aria-label="Role title"
        color="blue.500"
        borderColor="blue.200"
        borderRadius="lg"
      />
    ) : displayValue?.trim() ? (
      <Text>{displayValue}</Text>
    ) : (
      <Text color="gray.500">No role title yet</Text>
    )}
  </Box>
);

export default RoleTitleSection;
